export default __webpack_public_path__ + "static/media/JumpToAnswer.b30fc238.svg";